/** Local comparison route only; no router provider required by reusable room surfaces. */
export const useSessionCompareDesign = () =>
  import.meta.env.DEV &&
  typeof window !== 'undefined' &&
  window.location.pathname.includes('/preview/session-compare') &&
  new URLSearchParams(window.location.search).get('design') === 'proposed';

export const sessionCompareVoiceLabel = (locale: string) =>
  locale === 'ru' ? 'В голос' : 'Join voice';
